import { GenericApiResponse } from '@type/general';
import { GetDealsResult } from '@modules/deals/deals-list/types';
import restApi from '@services/api';

import { tableHeaderMapper } from './constants';
import { GetOpportunitiesPayload } from './types';
import {
  ApiTags,
  IS_INSIDERHUB,
  IS_PRE_IPO_DASHBOARD
} from '@constants/common';
import { OpportunityRegion } from '@modules/companies/create-company/constants';

const getOpportunityRegionParamIfApplicable: string = ((): string => {
  if (IS_PRE_IPO_DASHBOARD) {
    return `&opportunity_region=${OpportunityRegion.Global}`;
  }
  if (!IS_INSIDERHUB) {
    return `&opportunity_region=${OpportunityRegion.Indian}`;
  }
  return '';
})();

const GetUserVerificationApi = restApi.injectEndpoints({
  endpoints: builder => ({
    getOpportunitiesList: builder.query<
      GetDealsResult,
      GetOpportunitiesPayload
    >({
      query: ({ limit, offset, search, sort, order }) => ({
        url: `${
          process.env.REACT_APP_BASE_API_VERSION
        }/support/deal?opportunity_type=WaitList&limit=${limit}&offset=${offset}${
          search ? `&search=${encodeURIComponent(search)}` : ''
        }&sort=${
          tableHeaderMapper[sort as keyof typeof tableHeaderMapper] ??
          'start_time'
        }&order=${order}${getOpportunityRegionParamIfApplicable}`,
        method: 'GET'
      }),
      providesTags: [ApiTags.earlyAccess],
      transformResponse: (response: GenericApiResponse<GetDealsResult>) =>
        response.result
    }),
    getEarlyAccessList: builder.query<GetDealsResult, GetOpportunitiesPayload>({
      query: ({ limit, offset, search, sort, order }) => ({
        url: `${
          process.env.REACT_APP_BASE_API_VERSION
        }/support/deal?opportunity_type=WaitList&limit=${limit}&offset=${offset}${
          search ? `&search=${encodeURIComponent(search)}` : ''
        }&sort=${
          tableHeaderMapper[sort as keyof typeof tableHeaderMapper] ??
          'start_time'
        }&order=${order}${getOpportunityRegionParamIfApplicable}`,
        method: 'GET'
      }),
      providesTags: [ApiTags.earlyAccess],
      transformResponse: (response: GenericApiResponse<GetDealsResult>) =>
        response.result
    }),
    getWishlistList: builder.query<GetDealsResult, GetOpportunitiesPayload>({
      query: ({ limit, offset, search, sort, order }) => ({
        url: `${
          process.env.REACT_APP_BASE_API_VERSION
        }/support/deal?opportunity_type=WishList&limit=${limit}&offset=${offset}${
          search ? `&search=${encodeURIComponent(search)}` : ''
        }&sort=${
          tableHeaderMapper[sort as keyof typeof tableHeaderMapper]
        }&order=${order}${getOpportunityRegionParamIfApplicable}`,
        method: 'GET'
      }),
      providesTags: [ApiTags.wishlist],
      transformResponse: (response: GenericApiResponse<GetDealsResult>) =>
        response.result
    })
  })
});

export const {
  useGetOpportunitiesListQuery,
  useLazyGetOpportunitiesListQuery,
  useGetEarlyAccessListQuery,
  useLazyGetEarlyAccessListQuery,
  useGetWishlistListQuery,
  useLazyGetWishlistListQuery
} = GetUserVerificationApi;
